import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ChildlinkIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path id="Vector 467" d="M1 0V5.27273H7M7 5.27273L4.1875 2.54545M7 5.27273L4.1875 8" stroke={fillColor || 'white'} />
    </svg>
  );
};

export { ChildlinkIcon };
